import 'swiper/css/swiper.min.css';     

import React, { Component } from 'react';
import Swiper from 'swiper';

export default class CarouselComponent extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
        const isSafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);;
        new Swiper('.swiper-container',{
            loop: true,
            
            grabCursor : true,

            effect : isSafariBrowser ? "slide" : 'cube',

            autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction : false,
            },

            pagination :{
                el: '.swiper-pagination',
                clickable:true,
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            on:{
                click:  (e)=>{
                    if(e.target.localName === "img"){
                        this.props.playVideo();
                    }  
                }
            },
        });
    }

    render() {
        return (
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <img style={{width: "100%"}} src={require(`../assets/images/index_banner_1.png`)}/>
                    </div>
                    <div className="swiper-slide">
                        <img style={{width: '100%'}}  src={require(`../assets/images/index_banner_2.png`)}/>
                    </div>
                </div>
                <div className="swiper-pagination"></div>

                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </div>
        )
    }
}

